module.exports = __webpack_public_path__ + "static/media/TopLeftMenu.19910dd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Menus/TopLeftMenu.png
// module id = 71
// module chunks = 0